import { change } from 'redux-form';
import { CHECKOUT_FORM_NAME } from '../constants';
import {
    EB_MARKETING_OPT_IN_FIELD,
    ORG_MARKETING_OPT_IN_FIELD,
} from '../containers/checkout/constants';
import { isOrganizerInitiatedTransferOrder } from '../selectors/order';
import { isAddAttendeesOrder } from '../selectors/order/typedOrderSelectors';

export const initializeEBMarketingOptIn = () => (dispatch, getState) => {
    const state = getState();
    const shouldInitializeEBMarketingOptIn =
        !isAddAttendeesOrder(state) &&
        !isOrganizerInitiatedTransferOrder(state) &&
        state.app.featureFlags.enableEBMarketingOptInImplicit;

    if (!shouldInitializeEBMarketingOptIn) {
        return;
    }

    dispatch(change(CHECKOUT_FORM_NAME, EB_MARKETING_OPT_IN_FIELD, true));
    dispatch(change(CHECKOUT_FORM_NAME, ORG_MARKETING_OPT_IN_FIELD, true));
};
